import { firstValueFrom, map } from "rxjs";
import { environment } from "../../../environments/environment";
import { QuintisDadosSocioeconomicosDto } from "../../dtos/quintis-socioeconomicos-dto";
import { CaqRequestService } from "../caq-request/caq-request.service";
import { LocalizacaoService } from "../localizacao/localizacao.service";
import { Injectable } from "@angular/core";

export interface QuintisSocioeconomicosResponse<T> {
    content: T;
}

@Injectable({ providedIn: 'root' })
export class QuintisSocioeconomicosService {
    public urlBase = `${environment.apiUrl}/quintis/socioeconomicos`;

    constructor(
        private caqRequestService: CaqRequestService,
        private localizacaoService: LocalizacaoService
    ) { }

    async buscarPorLocalizacao(): Promise<QuintisDadosSocioeconomicosDto[]> {
        const url = this.construirUrl();
        return firstValueFrom(
            this.caqRequestService
                .get<QuintisSocioeconomicosResponse<QuintisDadosSocioeconomicosDto[]>>(url)
                .pipe(map(res => res.content))
        );
    }

    async buscarPorUf(codUf: number | string): Promise<QuintisDadosSocioeconomicosDto[]> {
        return firstValueFrom(
            this.caqRequestService
                .get<QuintisSocioeconomicosResponse<QuintisDadosSocioeconomicosDto[]>>(`${this.urlBase}/uf/${codUf}`)
                .pipe(map(res => res.content))
        );
    }

    async buscarNacional(): Promise<QuintisDadosSocioeconomicosDto[]> {
        return firstValueFrom(
            this.caqRequestService
                .get<QuintisSocioeconomicosResponse<QuintisDadosSocioeconomicosDto[]>>(`${this.urlBase}/nacional`)
                .pipe(map(res => res.content))
        );
    }

    private construirUrl(): string {
        const loc = this.localizacaoService.obterLocalizacaoSelecionada();

        if (loc?.estadoSelecionado?.value) {
            const codUf = loc.estadoSelecionado.value;
            return `${this.urlBase}/uf/${codUf}`;
        }

        return `${this.urlBase}/nacional`;
    }
}
